module.exports = __webpack_public_path__ + "img/zhuanpan-bg.7a02eb84.png";